// extracted by mini-css-extract-plugin
export default {"wrapper":"DdQPu1Fs4sMQ0CtgxkSZ"};